<style lang="less">
    .solid-fill {
        .last-item {
            margin-bottom: 0;
        }
    }
</style>

<template>
    <div class="solid-fill">
        <ColorSet :from="fmtType.fill" :fromPaintType="1" :index="0" @changeSet="$emit('changeSet')" />
    </div>
</template>

<script lang="ts">
    import ColorSet from "./ColorSet.vue";
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            ColorSet,
        },
    })
    export default class SolidFill extends Vue {
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }

        created() {}
    }
</script>
